'use strict';

//import ProductHelpers from '../product/base';
import { newModalFromSelector, newModalFromString } from '../components/modal';
import Notification from '../components/notification';

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 * @param {boolean} isMultipleItems - true if moving multiple items, show correct message
 */
function handlePostCartAdd (response, isMultipleItems) {
    $('body').trigger('count:update', response);

    if (isMultipleItems) {
        $('.add-to-cart-multiple').removeClass('hide');
    } else {
        $('.add-to-cart-single').removeClass('hide');
    }
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement () {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }

    var htmlString = `<!-- Modal -->
    <div class="modal fade" id="editWishlistProductModal" role="dialog">
        <div class="modal-dialog quick-view-dialog">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-body"></div>
                <div class="modal-footer"></div>
            </div>
        </div>
    </div>`;

    $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml (html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement (editProductUrl) {
    $.spinner().start();

    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'html',
        success: function (html) {
            const parsedHtml = parseHtml(html);

            $('#editWishlistProductModal .modal-body').empty();
            $('#editWishlistProductModal .modal-body').html(parsedHtml.body);
            $('#editWishlistProductModal .modal-footer').html(parsedHtml.footer);

            const modal = newModalFromSelector('editWishlistProductModal', false, ['quickview-modal']);

            $(modal.modalBox)
                .find('.product-quickview .carousel-inner').slick({
                    arrows: false,
                    dots: true
                });

            modal.open();
            $(modal.modalBox)
                .find('.close')
                .on('click', function (e) {
                    modal.close();
                });

            $('[data-dismiss="modal"]').on('click', function (e) {
                e.preventDefault();
                modal.close();
            });

            $.spinner().stop();
        },
        error: function () {
            $('#editWishlistProductModal').spinner().stop();
        }
    });
}

/**
 * show toast response
 * @param {Object} res - from the call to set the public status of a list or item in a list
 */
function showResponseMsg (res) {
    $.spinner().stop();
    var status;

    if (res.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append(
            '<div class="add-to-wishlist-messages "></div>'
        );
    }

    $('.add-to-wishlist-messages')
        .append('<div class="add-to-wishlist-alert text-center ' + status + '">' + res.msg + '</div>');

    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
    }, 3000);
}

/**
 * toggles the public / private status of the item or wishlist item
 * @param {string} listID - the order model
 * @param {string} itemID - the customer model
 * @param {Object} callback - function to run if the ajax call returns with an
 *                        error so that the checkbox can be reset to it's original state
 */
function updatePublicStatus (listID, itemID, callback) {
    var url = $('#isPublicList').data('url');
    $.spinner().start();
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: {
            listID: listID,
            itemID: itemID
        },
        success: function (data) {
            if (callback && !data.success) { callback(); }
            showResponseMsg(data, null);
        },
        error: function (err) {
            if (callback) { callback(); }
            showResponseMsg(err);
        }
    });
}
/**
 * @param {Object} $elementAppendTo - The element to append error html to
 * @param {string} msg - The error message
 * display error message if remove item from wishlist failed
 */
function displayErrorMessage ($elementAppendTo, msg) {
    if ($('.remove-from-wishlist-messages').length === 0) {
        $elementAppendTo.append(
            '<div class="remove-from-wishlist-messages "></div>'
        );
    }
    $('.remove-from-wishlist-messages')
        .append('<div class="remove-from-wishlist-alert text-center alert-danger">' + msg + '</div>');

    setTimeout(function () {
        $('.remove-from-wishlist-messages').remove();
    }, 3000);
}

/**
 * renders the list up to a given page number
 * @param {number} pageNumber - current page number
 * @param {boolean} spinner - if the spinner has already started
 */
function renderNewPageOfItems (pageNumber, spinner) {
    var publicView = $('.wishlistItemCardsData').data('public-view');
    var listUUID = $('.wishlistItemCardsData').data('uuid');
    var url = $('.wishlistItemCardsData').data('href');
    if (spinner) {
        $.spinner().start();
    }
    var newPageNumber = pageNumber;
    $.ajax({
        url: url,
        method: 'get',
        data: {
            pageNumber: ++newPageNumber,
            publicView: publicView,
            id: listUUID
        }
    }).done(function (data) {
        window.scrollTo({top: 0, behavior: 'smooth'});
        setTimeout(function () {
            $('.wishlistItemCards').empty();
            $('body .wishlistItemCards').parent().append(data);
        }, 3000);
    }).fail(function () {
        $('.more-wl-items').remove();
    });
    $.spinner().stop();
}

function checkAddAllButton () {
    if ($('.move-to-cart').length === $('.move-to-cart:disabled').length) {
        $('.add-all-to-cart').prop('disabled', true);
    }
}

/**
 * For color variation items in wishlist, when moved to cart, prompt a size selection
 * @param {string} pid - pid used to get variation
 * @param {string} url - url of the Controller
 * @return Compiled HTML
 */
const showSelectSize = (pid, url) => {
    $.spinner().start();
    $.ajax({
        url: url,
        method: 'GET',
        data: {
            pid: pid
        },
        success: function (data) {
            // Desktop
            if (Foundation.MediaQuery.atLeast('medium')) {
                // Append data and show window
                const $selectSizeContainer = $('.select-size-quick-add-container[data-pid="' + pid + '"]');
                $selectSizeContainer.append(data).removeClass('hidden');

                $.spinner().stop();

                // If click outside close select size
                $('body').on('click', '.page', e => {
                    if ($(e.target).closest('.select-size-quick-add-container').length === 0) {
                        $('.select-size-quick-add-container').addClass('hidden').empty();
                    }
                });

                // On select size
                $selectSizeContainer.on('click', 'input', e => {
                    e.preventDefault();

                    const selectedValue = $(e.currentTarget).attr('value');
                    if (selectedValue === 'null') {
                        return;
                    }

                    // Handle size click
                    let $productContainer = $(e.currentTarget).closest('.quickSizeModal');
                    if ($productContainer && $productContainer.length > 0) {
                        confirmSelectedSize(selectedValue, $productContainer, pid);
                    }
                });
            } else { // Mobile
                // create and open confirmation modal
                const modal = newModalFromString(data, false);
                $(modal.modalBox).addClass('quickselect-size-modal');
                modal.setContent(document.querySelector('.js-modal-quick-add-size-quantity').innerHTML);
                modal.open();
                $.spinner().stop();

                $(modal.modalBox).on('click', '.modal__closeIcon', () => {
                    modal.close();
                });
                $(modal.modalBox).on('click', 'input', e => {
                    e.preventDefault();
                    const selectedValue = $(e.currentTarget).attr('value');
                    if (selectedValue === 'null') {
                        return;
                    }
                    let $productContainer = $(e.currentTarget).closest('.quickSizeModal');
                    confirmSelectedSize(selectedValue, $productContainer, pid, modal);
                });
            }
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Confirm the size selection and move item to cart
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 * @param {string} pid - color variation product id that will be removed from wishlist
 * @param {jQuery} modal - modal that must be closed on mobile
 */
const confirmSelectedSize = (selectedValueUrl, $productContainer, pid, modal = false) => {
    $('body').trigger('product:beforeAttributeSelect', {
        url: selectedValueUrl,
        container: $productContainer
    });

    $.spinner().start();
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        success: data => {
            var moveToCartCTA = $productContainer.find('.move-to-cart');
            moveToCartCTA.attr('data-pid', data.product.id);
            moveToCartCTA.attr('data-color-variation-pid', pid);
            $productContainer.closest('.add-to-cart-wishList').find('.button-primary.move-to-cart').addClass('added-to-cart');
            moveToCartCTA.trigger('click');
            $('.select-size-quick-add-container').addClass('hidden').empty();
            $('.js-modal-quick-add-size-quantity').addClass('hidden')
                .find('.modal__closeIcon').trigger('click');
            if (modal) {
                modal.close();
            }
            $.spinner().stop();
        },
        error: () => {
            $.spinner().stop();
        }
    });
};

/**
 * Move current item to cart
 * @param {Object} form - Form object
 * @param {string} addToCartUrl - Controller URL
 * @param {jQuery} $productContainer - DOM element
 * @param {boolean} isMultipleItems - true if moving multiple items from wishlist to cart
 */
const moveToCart = (form, addToCartUrl, $productContainer, isMultipleItems = false) => {
    if (!addToCartUrl) {
        return;
    }

    $('body').trigger('product:beforeAddToCart', this);

    $.ajax({
        url: addToCartUrl,
        method: 'POST',
        data: form,
        success: function (data) {
            handlePostCartAdd(data, isMultipleItems);
            const $analyticsContainer = $productContainer.find('.analytics.productListingItem');
            if (!isMultipleItems) {
                $('body').trigger('product:afterAddToCart', { ...data, form, $productContainer, $analyticsContainer });
            }
            checkAddAllButton();

            let itemsOriginallyInWishlist = $('#wishlistItems').data('wishlistitems');
            let newItemsInWishlist = [];
            let itemsInWishlist = itemsOriginallyInWishlist.split(',');
            for (var i = 0; i < itemsInWishlist.length; i++) {
                if (itemsInWishlist[i] !== form.pid) {
                    newItemsInWishlist.push(itemsInWishlist[i]);
                }
            }
            $('#wishlistItems').data('#wishlistItems', itemsInWishlist.join(','));
            $('body').trigger('wishlist:update', data.wishlistTotal);

            var pageNumber = $('.wishlistItemCardsData').data('page-number') - 1;
            renderNewPageOfItems(pageNumber, false);
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

module.exports = {
    init: function () {
        checkAddAllButton();
    },

    addAllToCart: function () {
        $('body').on('click', '.add-all-to-cart', function () {
            let $allAddToCartBtns = $('.move-to-cart[data-size-selected="true"]');
            var allAddToCartItems = [];
            for (let i = 0; i < $allAddToCartBtns.length; i++) {
                let $btn = $allAddToCartBtns.eq(i);
                // If the button is disabled, the product is not in stock, skip it.
                if ($btn.prop('disabled')) {
                    if (i === $allAddToCartBtns.length - 1) {
                        $('body').trigger('product:afterAddAllToCartWishlist', { allAddToCartItems });
                    }
                    continue;
                } else {
                    $btn.addClass('added-to-cart');
                }
                let pid = $btn.data('pid');
                let addToCartUrl = $btn.data('url');
                let pidsQty = parseInt($btn.closest('.product-info').find('.quantity').val(), 10);
                let $productContainer = $btn.closest('.add-to-cart-wishList');

                const GTMIndex = $(this).closest('.analytics-wishlist-card-container').find('.analytics.productListingItem').data('index');
                const GTMParentItemId = $(this).closest('.analytics-wishlist-card-container').find('.analytics.productListingItem').data('parent_item_id');
                const GTMParentItemCategory4 = $(this).closest('.analytics-wishlist-card-container').find('.analytics.productListingItem').data('parent_item_category4');

                var form = {
                    pid: pid,
                    quantity: pidsQty || 1,
                    GTMItemListName: 'wishlist',
                    GTMItemListId: 'wishlist',
                    GTMIndex: GTMIndex
                };
                if (GTMParentItemId && GTMParentItemCategory4) {
                    form.GTMParentItemId = GTMParentItemId;
                    form.GTMParentItemCategory4 = GTMParentItemCategory4;
                }
                $(this).trigger('updateAddToCartFormData', form);

                moveToCart(form, addToCartUrl, $productContainer, $allAddToCartBtns.length > 1);
                let container = $btn.closest('.analytics-wishlist-card-container').find('.productListingItem.analytics');
                let additionalDataContainer = container.find('.clickAdditionalAttributes');
                if (form.pid) {
                    allAddToCartItems.push({...container.data(), ...additionalDataContainer.data()});
                }
                if (i === $('.move-to-cart').length - 1) {
                    location.reload();
                }
                if (i === $allAddToCartBtns.length - 1 && $allAddToCartBtns.length > 1) {
                    $('body').trigger('product:afterAddAllToCartWishlist', { allAddToCartItems });
                }
            }

            if ($('.move-to-cart[data-size-selected="false"]').length) {
                $('.select-size-message').removeClass('hide');
                window.scrollTo({top: 0, behavior: 'smooth'});
            }
        });
    },

    removeFromWishlist: function () {
        $('body').on('click', '.remove-from-wishlist', function (e) {
            e.preventDefault();
            var url = $(this).data('url');
            var pid = $(this).data('pid');
            var elMyAccount = $('.account-wishlist-item').length;

            // If user is in my account page, call removeWishlistAccount() end point, re-render wishlist cards
            if (elMyAccount > 0) {
                $.spinner().start();
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'html',
                    data: {},
                    success: function (html) {
                        $('body').trigger('wishlist:remove', { sku: pid, sender: 'my_account' });
                        window.location.reload();
                        $('.wishlist-account-card>.card').remove();
                        $('.wishlist-account-card').append(html);
                        $('.wishlist-account-card').spinner().stop();

                        const notification = new Notification();
                        notification.setContent(response.msg);
                        notification.show();
                        notification.timeout(5000);
                    },
                    error: function () {
                        var $elToAppend = $('.wishlist-account-card');
                        $elToAppend.spinner().stop();
                        var msg = $elToAppend.data('error-msg');
                        displayErrorMessage($elToAppend, msg);
                    }
                });
            // else user is in wishlist landing page, call removeProduct() end point, then remove this card
            } else {
                $.spinner().start();
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    data: {},
                    success: function (response) {
                        $('body').trigger('wishlist:remove', { sku: pid, sender: 'wishlist' });
                        var pageNumber = $('.wishlistItemCardsData').data('page-number') - 1;
                        renderNewPageOfItems(pageNumber, false);
                        $('body').trigger('wishlist:update', response.wishlistTotal);
                        forceShowFeedbackCart(pid, false);
                    },
                    error: function () {
                        $.spinner().stop();
                        var $elToAppendWL = $('.wishlistItemCards');
                        var msg = $elToAppendWL.data('error-msg');
                        displayErrorMessage($elToAppendWL, msg);
                    }
                });
            }
        });
        var timeoutFeedbackWishlist = null;
        function forceShowFeedbackCart (pid, isAdd) {
            forceHideFeedbackCart();
            if (timeoutFeedbackWishlist != null) {
                clearTimeout(timeoutFeedbackWishlist);
                timeoutFeedbackWishlist = null;
            }
            let container = $('.wishlist-section');

            container.addClass('open');

            var url = $('.wishlist-section').data('show-wishlist-cart-url') + '?pid=' + decodeURIComponent(pid) + '&fromWishlist=true&isAdd=' + isAdd;
            if (container.find('.wishlist-popover.show').length === 0) {
                $.get(url, function (data) {
                    container.find('.wishlist-popover').empty().append(data);
                    let hadClass = $('.wishlist-section .wishlist-popover').hasClass('show');
                    $('.wishlist-section .wishlist-popover').addClass('js-feedback-cart-popover');
                    container.find('.wishlist-popover').addClass('show');
                    $('.black-background').removeClass('hide');

                    let startTimer = true;
                    container.on('mouseenter focusin', (e) => {
                        if (timeoutFeedbackWishlist != null) {
                            clearTimeout(timeoutFeedbackWishlist);
                            timeoutFeedbackWishlist = null;
                        }
                    });
                    container.on('click', '.js_paypal_button', (e) => {
                        startTimer = false;
                        if (timeoutFeedbackWishlist != null) {
                            clearTimeout(timeoutFeedbackWishlist);
                            timeoutFeedbackWishlist = null;
                        }
                    });
                    container.on('mouseleave', (e) => {
                        if (!startTimer) {
                            return;
                        }

                        if (timeoutFeedbackWishlist != null) {
                            clearTimeout(timeoutFeedbackWishlist);
                            timeoutFeedbackWishlist = null;
                        }
                        timeoutFeedbackWishlist = setTimeout(() => {
                            forceHideFeedbackCart();
                        }, 3000);
                    });

                    if (timeoutFeedbackWishlist != null) {
                        clearTimeout(timeoutFeedbackWishlist);
                        timeoutFeedbackWishlist = null;
                    }
                    timeoutFeedbackWishlist = setTimeout(() => {
                        forceHideFeedbackCart();
                    }, 3000);
                    $(document).on('click touchstart', function (e) {
                        var targetContainer = container.find('.wishlist-popover');
                        if (!targetContainer.is(e.target) && targetContainer.has(e.target).length === 0) {
                            forceHideFeedbackCart();
                        }
                    });
                    $('.js-feedback-close-button').on('click', function (e) {
                        e.preventDefault();
                        forceHideFeedbackCart();
                    });
                });
            }
        };

        function forceHideFeedbackCart () {
            if (timeoutFeedbackWishlist != null) {
                clearTimeout(timeoutFeedbackWishlist);
                timeoutFeedbackWishlist = null;
            }
            $('.wishlist-section .wishlist-popover').removeClass('js-feedback-cart-popover');
            $('.wishlist-section .wishlist-popover').removeClass('show');
            $('.black-background').addClass('hide');
            $('.wishlist-section').removeClass('open');
        };
    },

    viewProductViaEdit: function () {
        $('body').on('click', '.edit-add-to-wishlist .edit', function (e) {
            e.preventDefault();

            var editProductUrl = $(this).attr('href');
            getModalHtmlElement();
            fillModalElement(editProductUrl);
        });
    },

    viewProductViaSelectAttribute: function () {
        $('body').on('click', '.select-attributes-btn', function (e) {
            e.preventDefault();

            var editProductUrl = $(this).data('get-product-url');
            getModalHtmlElement();
            fillModalElement(editProductUrl);
        });
    },

    updateWishlistUpdateButton: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            response.$productContainer.find('.btn-update-wishlist-product').attr('disabled', !response.product.readyToOrder || !response.product.available);
        });
    },
    /*
    updateWishListItem: function () {
        $('body').on('click', '.btn-update-wishlist-product', function (e) {
            e.preventDefault();

            var updateButtonBlock = $(this).closest('.wishlist-item-update-button-block').find('.update-wishlist-url');
            var updateProductUrl = updateButtonBlock.val();
            var uuid = updateButtonBlock.data('uuid');

            var form = {
                uuid: uuid,
                pid: ProductHelpers.methods.getPidValue($(e.currentTarget))
            };

            $.spinner().start();

            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function () {
                    $.spinner().start();
                    $('#editWishlistProductModal').spinner().stop();
                    $('#editWishlistProductModal').remove();
                    $('.modal-backdrop').remove();
                    $('body').removeClass('modal-open');
                    var pageNumber = $('.wishlistItemCardsData').data('page-number') - 1;
                    renderNewPageOfItems(pageNumber, false);
                },
                error: function () {
                    var msg = $('.btn-update-wishlist-product').data('error-msg');

                    $('#editWishlistProductModal').spinner().stop();
                    $('#editWishlistProductModal').remove();
                    $('.modal-backdrop').remove();
                    $('body').removeClass('modal-open');

                    if ($('.update-wishlist-messages').length === 0) {
                        $('body').append(
                            '<div class="update-wishlist-messages "></div>'
                        );
                    }

                    $('.update-wishlist-messages')
                        .append('<div class="update-wishlist-alert text-center alert-danger">' + msg + '</div>');

                    setTimeout(function () {
                        $('.update-wishlist-messages').remove();
                    }, 5000);
                }
            });
        });
    },
    */
    toggleWishlistStatus: function () {
        $('#isPublicList').on('click', function () {
            var listID = $('#isPublicList').data('id');
            updatePublicStatus(listID, null, null);
        });
    },

    toggleWishlistItemStatus: function () {
        $('body').on('click', '.wishlist-item-checkbox', function () {
            var itemID = $(this).closest('.wishlist-hide').find('.custom-control-input').data('id');
            var el = $(this).siblings('input');
            var resetCheckBox = function () {
                return el.prop('checked')
                    ? el.prop('checked', false)
                    : el.prop('checked', true);
            };

            updatePublicStatus(null, itemID, resetCheckBox);
        });
    },

    addToCartFromWishlist: function () {
        $('body').on('click', '.move-to-cart', function () {
            $('body').trigger('product:beforeAddToCart', this);
            $('.select-size-message').addClass('hide');

            var pid = $(this).data('pid');
            var addToCartUrl = $(this).data('url');
            var pidsQty = parseInt($(this).closest('.product-info').find('.quantity').val(), 10);
            var $productContainer = $(this).closest('.analytics-wishlist-card-container').find('.product-info');
            var colorVariationPid = $(this).data('color-variation-pid') || '';

            var isSizeSelected = $(this).data('size-selected');
            if (!isSizeSelected) {
                var selectSizeUrl = $(this).data('select-size-url');
                $(this).closest('.add-to-cart-wishList').find('.item-attribute-value--select-size').addClass('color-error');
                showSelectSize(pid, selectSizeUrl);
                $.spinner().stop();
                return;
            }

            const GTMIndex = $(this).closest('.analytics-wishlist-card-container').find('.analytics.productListingItem').data('index');
            const GTMParentItemId = $(this).closest('.analytics-wishlist-card-container').find('.analytics.productListingItem').data('parent_item_id');
            const GTMParentItemCategory4 = $(this).closest('.analytics-wishlist-card-container').find('.analytics.productListingItem').data('parent_item_category4');

            var form = {
                pid: pid,
                quantity: pidsQty || 1,
                colorVariationPid: colorVariationPid,
                GTMItemListName: 'wishlist',
                GTMItemListId: 'wishlist',
                GTMIndex: GTMIndex
            };
            if (GTMParentItemId && GTMParentItemCategory4) {
                form.GTMParentItemId = GTMParentItemId;
                form.GTMParentItemCategory4 = GTMParentItemCategory4;
            }

            $(this).addClass('added-to-cart');
            if ($(this).data('option')) {
                form.options = JSON.stringify($(this).data('option'));
            }

            $(this).trigger('updateAddToCartFormData', form);
            moveToCart(form, addToCartUrl, $productContainer);
        });
    },
    moreWLItems: function () {
        $('body').on('click', '.more-wl-items', function () {
            var pageNumber = $('.wishlistItemCardsData').data('page-number');
            renderNewPageOfItems(pageNumber, true);
        });
    },
    copyWishlistLink: function () {
        $('body').on('click', '.fa-link', function () {
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },
    submitWishlistSearch: function () {
        $('body').on('click', '#wishlist-search button', function (e) {
            var firstName = $('#wishlist-search-first-name').val();
            var lastName = $('#wishlist-search-last-name').val();
            var email = $('#wishlist-search-email').val();

            if ((!firstName && !lastName && !email)
                || (firstName && !lastName && !email)
                || (!firstName && lastName && !email)) {
                e.preventDefault();
                $('.wishlist-error-search div').addClass('alert alert-danger');
                var errorText = $('.wishlist-error-search').data('error-msg');
                $('.wishlist-error-search div').html(errorText);
            }
        });
    },
    moreWLSearchResults: function () {
        $('body').on('click', '.more-wl-results', function () {
            var firstName = $(this).data('search-fname');
            var lastName = $(this).data('search-lname');
            var pageNumber = $(this).data('page-number');
            var uuids = [];
            $('.wl-hit').each(function () {
                uuids.push($(this).find('a').data('id'));
            });
            var url = $(this).data('url');
            $.spinner().start();
            $.ajax({
                url: url,
                method: 'get',
                data: {
                    firstName: firstName,
                    lastName: lastName,
                    uuids: JSON.stringify(uuids),
                    pageNumber: ++pageNumber
                },
                success: function (data) {
                    if (data.results.changedList) {
                        $('.wl-hits .wl-hit').remove();
                    }
                    $('#result-count').html(data.results.totalString);
                    data.results.hits.forEach(function (hit) {
                        var divString = '<div class="row wl-hit">' +
                            '<div class="text-left col-6">' +
                                hit.firstName + ' ' + hit.lastName +
                            '</div>' +
                            '<div class="text-right col-6">' +
                                '<a href="' + hit.url + '" title="' + hit.urlTitle + '" data-id="' + hit.id + '">' +
                                    hit.urlText +
                                '</a>' +
                            '</div>' +
                            '<div class="text-left col-12">' +
                                hit.email +
                            '</div>' +
                        '</div>';
                        $('.wl-hits').append(divString);
                    });
                    if (data.results.showMore) {
                        $('.find-another-wl .more-wl-results').data('page-number', data.results.pageNumber);
                    } else {
                        $('.find-another-wl .more-wl-results').remove();
                    }
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    }
};
